import { render, staticRenderFns } from "./provide-tag-modal.vue?vue&type=template&id=ca26e56c"
import script from "./provide-tag-modal.vue?vue&type=script&lang=js"
export * from "./provide-tag-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports